import { useEffect } from 'react'
import { AppEmbed, EmbedEvent, MessagePayload, Page } from '@thoughtspot/visual-embed-sdk'
import EmbeddedContent from '../../components/EmbeddedContent'
import { logError } from '../../services/error/logger'
import { ALL_HIDDEN_ACTIONS } from '../../constants'
import { convertTsUrlToHfIntelligenceUrl } from '../../services/route/tsHfIntelligenceUrlMapper'
import { useNavigate } from 'react-router-dom'
import { IMessagePayload } from '../../types'

export const embedId = 'embed-subscriptions'

/**
 * Subsciption page accessible by the URL: /subscriptions
 * This page matches the Thoughtspot 'Monitor Subscriptions' page under Insights
 */

const Subscriptions = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const appEmbed = new AppEmbed(`#${embedId}`, {
      pageId: Page.Monitor,
      hiddenActions: ALL_HIDDEN_ACTIONS,
    })

    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Subscriptions: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }
    const handleRouteChange = (messagePayload: IMessagePayload) => {
      const route = messagePayload.data.currentPath
      navigate(convertTsUrlToHfIntelligenceUrl(route))
    }

    void appEmbed.on(EmbedEvent.Error, handleError).on(EmbedEvent.RouteChange, handleRouteChange).render()

    return () => {
      appEmbed.off(EmbedEvent.Error, handleError)
      appEmbed.off(EmbedEvent.RouteChange, handleRouteChange)
    }
  }, [navigate])

  return (
    <EmbeddedContent
      id={embedId}
      testId={embedId}
    />
  )
}

export default Subscriptions
